import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import Tooltip from "@material-ui/core/Tooltip"
import { useTranslations } from "./use-translations"
import { makeStyles, Theme } from "@material-ui/core"
import { Link, useLocation } from "react-router-dom"
import { useUrlWithContext } from "../../../hooks/use-url-with-context"
import { paths } from "../../../paths"
import { ProjectViewModel } from "../../api/project"
import { getActiveTabIndex } from "./utils"
import { useIsSmallScreen } from "../../../hooks/use-is-small-screen"
import { useCanViewReportedHoursTab } from "../../../hour-reports/hooks/use-can-view-reported-hours-tab"

const ProjectNavTabs = ({ project }: { project: ProjectViewModel }) => {
  const translations = useTranslations()
  const classes = useStyles()
  const { createPathWithContext } = useUrlWithContext()
  const location = useLocation()
  const isSmallScreen = useIsSmallScreen()
  const canViewReportedHoursTab = useCanViewReportedHoursTab()

  if (isSmallScreen) return null

  const tabValue = getActiveTabIndex(location.pathname, canViewReportedHoursTab)
  const basicRoute = createPathWithContext(paths.projectBasic(project.id))
  const ganttRoute = createPathWithContext(paths.projectGantt(project.id))
  const kanbanRoute = createPathWithContext(paths.projectKanban(project.id))
  const tasksRoute = createPathWithContext(paths.projectTasks(project.id))
  const todosRoute = `${createPathWithContext(paths.projectTodos(project.id))}&view=all`
  const calendarRoute = createPathWithContext(paths.projectCalendar(project.id))
  const reportedHoursRoute = createPathWithContext(paths.projectReportedHours(project.id))
  const dashboardRoute = createPathWithContext(paths.projectDashboard(project.id))

  return (
    <Tabs className={classes.tabs} value={tabValue} indicatorColor="primary" textColor="primary">
      <Tooltip title={translations.basicInfoTabLabel}>
        <Tab component={Link} to={basicRoute} className={classes.tab} label={translations.basicInfoTabLabel} />
      </Tooltip>
      <Tooltip title={translations.ganttChartTabLabel}>
        <Tab component={Link} to={ganttRoute} className={classes.tab} label={translations.ganttChartTabLabel} />
      </Tooltip>
      <Tooltip title={translations.tasksTabLabel}>
        <Tab component={Link} to={tasksRoute} className={classes.tab} label={translations.tasksTabLabel} />
      </Tooltip>
      <Tooltip title={translations.todoListTabLabel}>
        <Tab component={Link} to={todosRoute} className={classes.tab} label={translations.todoListTabLabel} />
      </Tooltip>
      <Tooltip title={translations.calendarTabLabel}>
        <Tab component={Link} to={calendarRoute} className={classes.tab} label={translations.calendarTabLabel} />
      </Tooltip>
      <Tooltip title={translations.kanbanTabLabel}>
        <Tab component={Link} to={kanbanRoute} className={classes.tab} label={translations.kanbanTabLabel} />
      </Tooltip>
      {canViewReportedHoursTab ? (
        <Tooltip title={translations.reportedHoursTabLabel}>
          <Tab
            component={Link}
            to={reportedHoursRoute}
            className={classes.tab}
            label={translations.reportedHoursTabLabel}
          />
        </Tooltip>
      ) : null}
      <Tooltip title={translations.dashboardTabLabel}>
        <Tab component={Link} to={dashboardRoute} className={classes.tab} label={translations.dashboardTabLabel} />
      </Tooltip>
    </Tabs>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  tab: {
    maxWidth: 160,
    minWidth: 96,
    minHeight: 32,
    fontSize: 13,
    padding: `2px 12px`,
    "& .MuiTab-wrapper": {
      display: "block",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
  },
  tabs: {
    marginTop: theme.spacing(2),
    "& .MuiTabs-indicator": {
      top: 36,
    },
  },
}))

export default ProjectNavTabs
